/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    open?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    automatic?: boolean;
}

/**
 * Check if a given object implements the ApplicationContextClassLoaderParentUnnamedModuleDescriptor interface.
 */
export function instanceOfApplicationContextClassLoaderParentUnnamedModuleDescriptor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSON(json: any): ApplicationContextClassLoaderParentUnnamedModuleDescriptor {
    return ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSONTyped(json, false);
}

export function ApplicationContextClassLoaderParentUnnamedModuleDescriptorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContextClassLoaderParentUnnamedModuleDescriptor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'open': !exists(json, 'open') ? undefined : json['open'],
        'automatic': !exists(json, 'automatic') ? undefined : json['automatic'],
    };
}

export function ApplicationContextClassLoaderParentUnnamedModuleDescriptorToJSON(value?: ApplicationContextClassLoaderParentUnnamedModuleDescriptor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'open': value.open,
        'automatic': value.automatic,
    };
}

